import React from "react";

export const arrowForward = () => {
  return (
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="arrow_forward_24px">
        <path
          id="icon/navigation/arrow_forward_24px"
          d="M12 4L10.59 5.41L16.17 11H4V13H16.17L10.59 18.59L12 20L20 12L12 4Z"
          fill="currentColor"
        />
      </g>
    </svg>
  );
};
